













  import { Validable } from '@/commun/components/champ-formulaire/mixins/validable';
  import Vue from 'vue';

  export default Vue.extend({
    name: 'TitreCoursTextfield',
    mixins: [Validable],
    props: {
      maximumCaracteres: {
        type: Number,
        default: 60,
      },
      nom: {
        type: String,
        default() {
          return this.$t('demande.formulaires.champs.titre-du-cours.nom');
        },
      },
      value: {
        type: String,
        default: '',
      },
    },
  });
